export enum TableEditMode {
  Row = 'row',
  Cell = 'cell'
}
